import React from 'react';
import {
  TableHead as MUTableHead,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import { HeadCell } from 'models/tables';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerText: {
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
);

interface Props {
  cells: HeadCell[];
}

const TableHead: React.FC<Props> = (props) => {
  const { cells } = props;
  const classes = useStyles();

  return (
    <MUTableHead>
      <TableRow>
        {cells.map((cell) => (
          <TableCell key={cell.id}>
            <Typography variant='subtitle1' className={classes.headerText}>
              {cell.label}
            </Typography>
          </TableCell>
        ))}
      </TableRow>
    </MUTableHead>
  );
};

export default TableHead;
